import { createEvent } from 'effector'

import type { Toast } from '@/components/ui/toast.tsx'

export let toast: {
  success: (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ) => void
  error: (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ) => void
  warning: (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ) => void
  info: (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ) => void
} = {
  success: function (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ): void {
    throw new Error('Function not implemented.')
  },
  error: function (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ): void {
    throw new Error('Function not implemented.')
  },
  warning: function (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ): void {
    throw new Error('Function not implemented.')
  },
  info: function (
    title: string,
    payload?: Omit<Toast, 'open' | 'status' | 'title'>,
  ): void {
    throw new Error('Function not implemented.')
  },
}

export function setToastFunction(fn: typeof toast) {
  toast = fn
}

export const showToastSuccess = createEvent<string>('show toast success')
showToastSuccess.watch((text) => toast.success(text))

export const showToastError = createEvent<string>('show toast error')
showToastError.watch((text) => toast.error(text))
